<template>
  <div>
    <v-card class="card--shadow">
      <v-card-text>
        <!-- PATIENT INFO SECTION -->
        <v-row>
          <v-col lg="4">
            <label>Name</label>
            <v-text-field
              v-model.trim="familyMember.name"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col lg="4">
            <label>Age</label>
            <v-text-field
              v-model.trim="familyMember.age"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Sex</label>
            <v-radio-group v-model="familyMember.sex" row>
              <v-radio label="Male" value="1"></v-radio>
              <v-radio label="Female" value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="4" >
            <label>Eligible</label>
            <v-radio-group v-model="familyMember.eligible" row>
              <v-radio label="Yes" value="2"></v-radio>
              <v-radio label="No" value="1"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col lg="4" v-if="familyMember.eligible=='1'">
            <label>Reason</label>
            
            <v-text-field v-model.trim="familyMember.reason" type="text" filled dense></v-text-field>
          </v-col>
          <v-col-4>
            <br>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="form-btn" @click="emitData">
                  <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
                </v-btn>
              </v-card-actions>
          </v-col-4>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    familyMember: {
      type: Object,
      default: () => {
        return {
          name: null,
          age: null,
          sex: null,
        };
      },
    },
  },
  computed: {
    ...mapState("Admin", ["isRoleProgram"]),
  },
  methods: {
    emitData() {
      let data = {
        name: this.familyMember.name,
        sex: this.familyMember.sex,
        age: this.familyMember.age,
        patient_id: this.$route.params.patient_id,
        eligible:this.familyMember.eligible,
        reason:this.familyMember.reason
      };
      this.$emit("emitData", data);

       // Clear the input fields
       this.familyMember = {
        name: '',
        sex: '',
        age: '',
        reason:'',
        eligible:'2',
      };
    },
  },
};
</script>

<style>
</style>